import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OKTA_AUTH, OktaAuthGuard } from '@okta/okta-angular';
import { TokenService } from '@utilities/services/token.service';

export const dynamicAuthGuard: CanActivateFn = async (route, state) => {
  const oktaToken = inject(OKTA_AUTH).getAccessToken();
  const oktaGuard = inject(OktaAuthGuard);

  if (oktaToken) {
    const result = await oktaGuard.canActivate(route, state);
    return result as boolean;
  }

  const tokenService = inject(TokenService);
  const token = tokenService.getToken();

  if (token) {
    return true;
  }

  return false;
};
